export const userPreferences = {
	displayLanguage: "en",
	translationLanguages: ["en", "ar"],
	defaultTranslationLanguage: "ar",
};

export default userPreferences;
